export const colors = [
	'#f44336',
	'#ffa726',
	'#ffeb3b',
	'#4caf50',
	'#42a5f5',
	'#9c27b0',
	'#3f51b5',
	'#ec407a',
	'#d32f2f',
	'#fb8c00',
	'#fdd835',
	'#388e3c',
	'#1976d2',
	'#7b1fa2',
	'#303f9f',
	'#e91e63',
	'#b71c1c',
	'#ef6c00',
	'#fbc02d',
	'#1b5e20',
	'#0d47a1',
	'#4a148c',
	'#1a237e',
	'#c2185b'
];

export const stateOptions = [
	{ value: 'AL', text: 'AL' },
	{ value: 'AK', text: 'AK' },
	{ value: 'AZ', text: 'AZ' },
	{ value: 'AR', text: 'AR' },
	{ value: 'CA', text: 'CA' },
	{ value: 'CO', text: 'CO' },
	{ value: 'CT', text: 'CT' },
	{ value: 'DE', text: 'DE' },
	{ value: 'DC', text: 'DC' },
	{ value: 'FL', text: 'FL' },
	{ value: 'GA', text: 'GA' },
	{ value: 'HI', text: 'HI' },
	{ value: 'ID', text: 'ID' },
	{ value: 'IL', text: 'IL' },
	{ value: 'IN', text: 'IN' },
	{ value: 'IA', text: 'IA' },
	{ value: 'KS', text: 'KS' },
	{ value: 'KY', text: 'KY' },
	{ value: 'LA', text: 'LA' },
	{ value: 'ME', text: 'ME' },
	{ value: 'MD', text: 'MD' },
	{ value: 'MA', text: 'MA' },
	{ value: 'MI', text: 'MI' },
	{ value: 'MN', text: 'MN' },
	{ value: 'MS', text: 'MS' },
	{ value: 'MO', text: 'MO' },
	{ value: 'MT', text: 'MT' },
	{ value: 'NE', text: 'NE' },
	{ value: 'NV', text: 'NV' },
	{ value: 'NH', text: 'NH' },
	{ value: 'NJ', text: 'NJ' },
	{ value: 'NM', text: 'NM' },
	{ value: 'NY', text: 'NY' },
	{ value: 'NC', text: 'NC' },
	{ value: 'ND', text: 'ND' },
	{ value: 'OH', text: 'OH' },
	{ value: 'OK', text: 'OK' },
	{ value: 'OR', text: 'OR' },
	{ value: 'PA', text: 'PA' },
	{ value: 'RI', text: 'RI' },
	{ value: 'SC', text: 'SC' },
	{ value: 'SD', text: 'SD' },
	{ value: 'TN', text: 'TN' },
	{ value: 'TX', text: 'TX' },
	{ value: 'UT', text: 'UT' },
	{ value: 'VT', text: 'VT' },
	{ value: 'VA', text: 'VA' },
	{ value: 'WA', text: 'WA' },
	{ value: 'WV', text: 'WV' },
	{ value: 'WI', text: 'WI' },
	{ value: 'WY', text: 'WY' }
];
